import * as React from "react";

import { cn } from "@/lib/utils";

// Figma "Form Field": label (14/22 medium) + 48px input with 1px border.
export interface NvFormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  required?: boolean;
  error?: string;
  // 입력 칸에만 덧붙이는 클래스 (바깥 래퍼는 className)
  inputClassName?: string;
}

const NvFormField = React.forwardRef<HTMLInputElement, NvFormFieldProps>(
  ({ label, required, error, id, className, inputClassName, ...props }, ref) => {
    const autoId = React.useId();
    const inputId = id ?? autoId;
    return (
      <div className={cn("flex flex-col gap-[6px]", className)}>
        <label htmlFor={inputId} className="text-nv-label-md text-nv-text-strong">
          {label}
          {required && " *"}
        </label>
        <input
          ref={ref}
          id={inputId}
          required={required}
          aria-invalid={error ? true : undefined}
          className={cn(
            "rounded-nv-control border bg-nv-surface px-[14px] py-3 text-nv-body-md text-nv-text-strong placeholder:text-nv-text-placeholder focus-visible:border-nv-brand focus-visible:outline-none disabled:bg-nv-bg-subtle disabled:text-nv-text-disabled read-only:bg-nv-bg-subtle read-only:text-nv-text-secondary",
            error ? "border-nv-danger" : "border-nv-border-strong",
            inputClassName,
          )}
          {...props}
        />
        {error && <p className="text-nv-caption text-nv-danger">{error}</p>}
      </div>
    );
  },
);
NvFormField.displayName = "NvFormField";

export { NvFormField };
